import { useForm } from 'react-hook-form';

// @Utility
import validateInput from "@utility/app/validateInput";

// Component
import Grid from '@mui/material/Grid';

// Icon
import PhoneIcon from '@mui/icons-material/Phone';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PersonIcon from '@mui/icons-material/Person';

export default function Register01App(props) {
    const { register, handleSubmit, formState: { errors } } = useForm();

    const clickBank = (data) => {
        props.setSelectBank(data);
    };

    const renderErrorPhone = () => {
        if (!errors.phone) return null;

        return (
            <div className="validateError">
                {errors.phone.message || "กรุณาระบุเบอร์โทรศัพท์ให้ถูกต้อง"}
            </div>
        );
    };

    const renderErrorBankAccount = () => {
        if (!errors.bank_account) return null;

        return (
            <div className="validateError">
                {errors.bank_account.message || "กรอกเลขบัญชีธนาคารให้ถูกต้อง"}
            </div>
        );
    };

    const renderErrorBankAccountName = () => {
        if (errors.bank_account_name) {
            return (
                <div className="validateError">
                    {errors.bank_account_name.message || "กรุณากรอกชื่อบัญชีธนาคารให้ถูกต้อง"}
                </div>
            );
        }

        // ไม่มี error → แสดงข้อความช่วยอธิบาย
        return (
            <div className="validateInfo left">
                กรอกชื่อ-สกุล ไม่ต้องกรอกคำนำหน้า และไม่ต้องใส่เครื่องหมาย (-)
            </div>
        );
    };

    return (
        <>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <Grid container>
                    <Grid item xs={12}>
                        <br />
                        <div className="inputPaddingRegisterTop">
                            <div className="inputTextLabel">
                                เบอร์โทรศัพท์*
                            </div>
                            <Grid container alignItems="center" className="inputStyles center" >
                                <Grid item xs={2}>
                                    <PhoneIcon className="iconSize" />
                                </Grid>
                                <Grid item xs={10}>
                                    <input
                                        id="register_phone"
                                        type="tel"
                                        inputMode="numeric"
                                        className="inputStyles inputStylesBorderNone"
                                        placeholder="เบอร์โทรศัพท์"
                                        maxLength={10}
                                        {...register("phone", {
                                            required: "กรุณากรอกเบอร์โทรศัพท์",
                                            minLength: {
                                                value: 10,
                                                message:
                                                    "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก"
                                            },
                                            maxLength: {
                                                value: 10,
                                                message:
                                                    "กรุณากรอกเบอร์โทรศัพท์ไม่เกิน 10 หลัก"
                                            },
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message:
                                                    "เบอร์โทรศัพท์ต้องเป็นตัวเลขเท่านั้น (0–9)"
                                            }
                                        })}
                                        onKeyDown={(event) =>
                                            validateInput(event, "number")
                                        }
                                        onPaste={(event) =>
                                            validateInput(event, "number")
                                        }
                                    />
                                </Grid>
                            </Grid>
                            {
                                renderErrorPhone()
                            }
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="inputPaddingRegisterTop">
                            <div className="inputTextLabel">
                                กรุณาเลือกธนาคาร
                            </div>
                            <Grid container spacing={1}>
                                {
                                    props?.bankList !== undefined && (
                                        props.bankList !== null && (
                                            props.bankList.map((item, index) => (
                                                <Grid key={index} item xs={2}>
                                                    <img className={["imgBank", props.selectBank === item.bank_switfcode ? "" : "imgBankNotSelect"].join(" ")} src={item.bank_img} alt="bank list" onClick={() => clickBank(item.bank_switfcode)} />
                                                </Grid>
                                            ))
                                        )
                                    )
                                }
                            </Grid>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="inputPaddingRegisterTop">
                            <div className="inputTextLabel">
                                เลขบัญชีธนาคาร*
                            </div>
                            <Grid container alignItems="center" className="inputStyles center" >
                                <Grid item xs={2}>
                                    <AccountBalanceIcon className="iconSize" />
                                </Grid>
                                <Grid item xs={10}>
                                    <input
                                        type="tel"
                                        inputMode="numeric"
                                        className="inputStyles inputStylesBorderNone"
                                        placeholder="กรอกเลขบัญชีธนาคาร"
                                        maxLength={13}
                                        {...register("bank_account", {
                                            required:
                                                "กรุณากรอกเลขบัญชีธนาคาร",
                                            minLength: {
                                                value: 10,
                                                message:
                                                    "กรุณากรอกเลขบัญชีธนาคารอย่างน้อย 10 หลัก"
                                            },
                                            maxLength: {
                                                value: 13,
                                                message:
                                                    "เลขบัญชีธนาคารต้องไม่เกิน 13 หลัก"
                                            },
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message:
                                                    "เลขบัญชีธนาคารต้องเป็นตัวเลขเท่านั้น (0–9)"
                                            }
                                        })}
                                        onKeyDown={(event) =>
                                            validateInput(event, "number")
                                        }
                                        onPaste={(event) =>
                                            validateInput(event, "number")
                                        }
                                    />
                                </Grid>
                            </Grid>
                            {
                                renderErrorBankAccount()
                            }
                        </div>
                    </Grid>
                    {
                        props.showAccName && (
                            <Grid item xs={12}>
                                <div className="inputPaddingRegisterTop">
                                    <div className="inputTextLabel">
                                        ชื่อ - นามสกุล*
                                    </div>
                                    <Grid container alignItems="center" className="inputStyles center" >
                                        <Grid item xs={2}>
                                            <PersonIcon className="iconSize" />
                                        </Grid>
                                        <Grid item xs={10}>
                                            <input
                                                type="text"
                                                className="inputStyles inputStylesPadding inputStylesBorderNone"
                                                placeholder="ชื่อ-สกุล"
                                                maxLength={50}
                                                {...register("bank_account_name", {
                                                    required:
                                                        "กรุณากรอกชื่อบัญชีธนาคาร",
                                                    minLength: {
                                                        value: 2,
                                                        message:
                                                            "กรุณากรอกชื่อบัญชีธนาคารให้ถูกต้อง"
                                                    },
                                                    maxLength: {
                                                        value: 50,
                                                        message:
                                                            "ชื่อบัญชีธนาคารต้องไม่เกิน 50 ตัวอักษร"
                                                    },
                                                    pattern: {
                                                        value: /^[a-zA-Zก-๙ ]+$/i,
                                                        message:
                                                            "ชื่อบัญชีต้องเป็นตัวอักษรไทยหรืออังกฤษเท่านั้น"
                                                    }
                                                })}
                                                onKeyDown={(event) =>
                                                    validateInput(event, "")
                                                }
                                                onPaste={(event) =>
                                                    validateInput(event, "")
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                    {
                                        renderErrorBankAccountName()
                                    }
                                </div>
                            </Grid>
                        )
                    }
                </Grid>

                <div className="inputPaddingTop center boxMarginTop">
                    <button id="register_button" type="submit" className="btn btnLogin btnHover btnWidthLarge btnRadius textBoldHight">
                        สมัครสมาชิก
                    </button>
                </div>
            </form>

            <div className="boxMarginTop center">
                <div className="inputNotRegister">
                    เป็นสมาชิกอยู่เเล้ว?
                </div>

                <div className="boxMarginTop">
                    <button className="btn btnConfirm btnHover btnWidthLarge btnRadius textBoldHight" onClick={() => { props.switchChanel("login") }}>
                        เข้าสู่ระบบ
                    </button>
                </div>
            </div>
        </>
    );
}